'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import { getBuilderPreviewMode } from '@src/utils/builder.util';
import { cn } from '@src/utils/tailwind';
export interface FooterAccordionItem {
  titleContent: any[];
  content: any[];
}
export interface FooterAccordionProps {
  items: FooterAccordionItem[];
  builderBlock?: any;
}
export const FooterAccordion = t0 => {
  const $ = _c(6);
  const {
    items,
    builderBlock
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getBuilderPreviewMode();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    edit
  } = t1;
  let t2;
  if ($[1] !== builderBlock?.id || $[2] !== items) {
    t2 = items?.map((item, index) => <Disclosure as="div" key={index} defaultOpen={edit || items.length === 1} className="border-t border-bodi-gray-light py-4 last:border-b data-open:pb-2">{t3 => {
        const {
          open
        } = t3;
        return <><DisclosureButton className="flex w-full items-center justify-between"><BuilderBlocks child={true} parentElementId={builderBlock?.id} dataPath={`component.options.items.${index}.titleContent`} blocks={item.titleContent} />{open ? <MinusIcon className="size-6 text-bodi-gray-medium" /> : <PlusIcon className="size-6 text-bodi-gray-medium" />}</DisclosureButton><div className={cn("grid pl-4 transition-all duration-300 ease-out", open ? "grid-rows-[1fr] opacity-100 pt-4" : "grid-rows-[0fr] opacity-0")}><DisclosurePanel static={true} className="flex flex-col gap-1 overflow-hidden [&_a:hover]:underline"><BuilderBlocks child={true} parentElementId={builderBlock?.id} dataPath={`component.options.items.${index}.content`} blocks={item.content} /></DisclosurePanel></div></>;
      }}</Disclosure>);
    $[1] = builderBlock?.id;
    $[2] = items;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div>{t2}</div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};